import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  LoadingSm,
} from "@medimo/ui";
import { useConfirmForm } from "../../hooks/use-confirm-form";

type ConfirmFormProps = {
  email: string;
  isPending: boolean;
  onVerifyCode: VoidFunction;
  navigateToHome: VoidFunction;
  onSubmit?: VoidFunction;
};

export const ConfirmForm = ({
  email,
  isPending,
  onVerifyCode,
  navigateToHome,
  onSubmit,
}: ConfirmFormProps) => {
  const { form, handleSubmit, handleResendSignUpCodeOnClick, isLoading } =
    useConfirmForm({
      email,
      onVerifyCode,
      navigateToHome,
      onSubmit,
    });

  const code = form.watch("code");

  return (
    <Form {...form}>
      <form className="space-y-6" onSubmit={handleSubmit}>
        <FormField
          control={form.control}
          name="code"
          render={({ field }) => (
            <FormItem>
              <FormLabel>認証コード</FormLabel>
              <FormControl>
                <Input
                  autoComplete="one-time-code"
                  inputMode="numeric"
                  type="text"
                  {...field}
                  onBlur={() => {
                    field.onChange(field.value.trim());
                    field.onBlur();
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormMessage>{form.formState.errors.root?.message}</FormMessage>
        <Button
          className="flex w-full gap-3"
          disabled={isPending || isLoading || !code.trim()}
          type="submit"
        >
          {isPending || isLoading ? <LoadingSm /> : "プロフィールの登録へ進む"}
        </Button>
        <div className="space-y-3">
          <p className="text-muted-foreground text-xs leading-relaxed">
            メールが届かない場合や、認証コードの有効期限が切れた場合はもう一度送信してください
          </p>
          <div className="text-center">
            <button
              className="text-sm underline"
              onClick={handleResendSignUpCodeOnClick}
              type="button"
            >
              認証コードを送信
            </button>
          </div>
        </div>
      </form>
    </Form>
  );
};
